import { MDText } from 'i18n-react';

import { KYC_BASE_PATH } from 'Components/pages/AccountSettings/AccountSettingsCompanyInformation/AccountSettingsCompanyInformation.helpers';

import { TextCTA } from '../../TextCTA/TextCTA';
import biddingSectionCTAStateControllerTexts from '../BiddingSectionCTAStateController.texts';

const kycFrozenLocalT = new MDText(biddingSectionCTAStateControllerTexts.biddingKycFrozen);

export const BiddingKycFrozen: React.FC = () => (
	<TextCTA
		buttonProps={{
			href: KYC_BASE_PATH,
			text: `${kycFrozenLocalT.translate('buttonText')}`,
		}}
		description={`${kycFrozenLocalT.translate('description')}`}
		title={`${kycFrozenLocalT.translate('title')}`}
	/>
);
